module.exports = "/img/cj-hol_bg.png?bd86a6d72538455b5d1644df29e9e49e";